const CURRENCY_CODE_TO_SYMBOL = {
  BRL: "R$",
  EUR: "€",
  USD: "$",
  GBP: "£",
  MXN: "$",
  TRY: "₺",
};

/**
 * Converte código de moeda (BRL, USD, EUR, etc.) para o símbolo de exibição (R$, $, €, etc.).
 * Use para exibir valores em texto. Não use para InputNumber/Intl.NumberFormat (esses exigem código ISO).
 * @param {string} currencyCode - Código ISO da moeda (ex: "BRL", "USD")
 * @returns {string} Símbolo da moeda ou o próprio código se não houver mapeamento
 */
export function getCurrencySymbol(currencyCode) {
  if (!currencyCode || typeof currencyCode !== "string") return "€";
  const normalized = currencyCode.toUpperCase().trim();
  if (CURRENCY_CODE_TO_SYMBOL[normalized]) {
    return CURRENCY_CODE_TO_SYMBOL[normalized];
  }

  // Tenta descobrir símbolo para códigos ISO válidos que não estejam no mapa estático.
  if (/^[A-Z]{3}$/.test(normalized)) {
    try {
      const parts = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: normalized,
        currencyDisplay: "narrowSymbol",
      }).formatToParts(0);
      const currencyPart = parts.find((part) => part.type === "currency");
      if (currencyPart?.value) {
        return currencyPart.value;
      }
    } catch (error) {
      console.error(error);
    }
  }

  return normalized;
}

/**
 * Retorna o código ISO da moeda (BRL, EUR, USD, etc.) para uso em InputNumber mode="currency",
 * Intl.NumberFormat e APIs que esperam código, não símbolo.
 */
function handleCurrency(currency) {
  if (!currency || typeof currency !== "string") return "USD";
  const normalized = currency.toUpperCase().trim();
  const known = ["BRL", "EUR", "USD", "GBP", "MXN", "TRY"];
  return known.includes(normalized) ? normalized : "USD";
}

export default handleCurrency;
